<template>
  <div class="loginBody">
    <form v-loading="loading">
      <el-image
      style="width: 130px; height: 100px"
      :src="url"
      :fit="fit"></el-image>
       <h3 style="margin-top:5%"><b>Нэвтрэх</b></h3>
      <el-form ref="form" label-width="120px" :label-position="labelPosition">
        <el-form-item >
        <el-input style="width:400px;margin-top:40px" placeholder="Мэйл хаягаа оруулна уу" v-model="username" type="email" />
        </el-form-item>
          <el-form-item >
        <el-input style="width:400px;margin-top:20px" placeholder="Нууц үгээ оруулна уу" v-model="password" type="password" />
        </el-form-item>
      </el-form>
      <el-button style="width:400px; margin-top:20px; background-color:gray; color: white" variant="danger" @click="login">НЭВТРЭХ</el-button>
    </form>
  </div>
</template>

<script>
import { signIn } from '@/utils/auth.js'
import toktokLogo from '../../src/assets/toktok_logo.png'
export default {
  data () {
    return {
      fit: 'fill',
      labelPosition: 'top',
      username: '',
      password: '',
      url: toktokLogo,
      loading: false
    }
  },
  methods: {
    login () {
      this.loading = true
      signIn(this.username, this.password)
      this.$store.commit('addToUserType', 'employee')
      this.loading = false
    }
  }
}

</script>
<style scoped>
.loginBody{
  margin-top: 10%;
  text-align: center
}
</style>
